import React from 'react';
import "./Container.scss";

export default function Container(props) {
  const { icon } = props;

  let className = "wordInterventionModal ";
  if (props.className) className += props.className;

  return (
    <div className={className} onTouchMove={onTouchMove}>
      <div className="centered">{props.children}</div>
      {!!icon && <img src={icon} className="intervention-icon" alt="" />}
    </div>
  );

  function onTouchMove(e) {
    if (props.onTouchMove) props.onTouchMove(e);
  }
}
